<script setup lang="ts">
import ContentContainer from '@/components/layout/ContentContainer.vue';
import ContentColumn from '@/components/layout/ContentColumn.vue';

defineProps<{
  text: string;
}>();
</script>

<template>
  <ContentContainer class="quote-container">
    <ContentColumn>
      <p class="quote-content">
        {{ text }}
      </p>
    </ContentColumn>
  </ContentContainer>
</template>

<style lang="scss" scoped>
@use "@/assets/styles/shared/screen" as screen;

.quote-container {
  margin-bottom: var(--spacing-m);

  :deep(.content-container) {
    *:last-child {
      margin-bottom: 0;
    }
  }
}

.quote-content {
  font-family: var(--font-secondary);
  font-size: 3.2rem;
  font-weight: 700;
  line-height: 1.15;

  @include screen.respond(tablet) {
    font-size: 2.8rem;
  }

  @include screen.respond(mobile) {
    padding-top: var(--spacing-m);
    padding-bottom: var(--spacing-m);
    border-top: 1px solid var(--colour-black);
  }
}
</style>
